import { format } from "date-fns";
import { BUSINESS_TYPE_OPTIONS, COA_TYPES_FOR_TX } from "@/components/TransactionForm";

let seq = 0;
export const newLine = (prev) => ({
  key: `l${Date.now()}_${seq++}`,
  date: prev?.date || format(new Date(), "yyyy-MM-dd"),
  type: prev?.type || "expense",
  business_kind: prev?.business_kind || "expense",
  category: "",
  coa_code: "none",
  account_id: prev?.account_id || "none",
  note: "",
  amount: "",
});

export const duplicateLine = (l) => ({ ...l, key: `l${Date.now()}_${seq++}` });

export const lineCurrency = (line, accounts, fallback) =>
  accounts.find((a) => a.id === line.account_id)?.currency || fallback;

export const isBlank = (l) => !l.category && !l.amount && !l.note;

export const lineErrors = (l) => ({
  ...Object.fromEntries(Object.keys(l.unmatched || {}).map((k) => [k, true])),
  date: !l.date,
  category: !l.category,
  amount: !(Number(l.amount) > 0),
});

export const coaOptionsFor = (line, coa, isBusiness) => {
  if (!isBusiness) return [];
  const kind = BUSINESS_TYPE_OPTIONS.find((o) => o.value === line.business_kind);
  const allowed = kind?.coa || COA_TYPES_FOR_TX[line.type] || [];
  return coa
    .filter((c) => c.is_active !== false && allowed.includes(c.type))
    .sort((a, b) => (a.code || "").localeCompare(b.code || ""));
};

export const toPayload = (l, accounts, fallback) => ({
  type: l.type,
  amount: Number(l.amount),
  category: l.category,
  note: l.note || "",
  date: l.date,
  currency: lineCurrency(l, accounts, fallback),
  account_id: !l.account_id || l.account_id === "none" ? null : l.account_id,
  coa_code: l.coa_code && l.coa_code !== "none" ? l.coa_code : null,
});

export const SIGN = { income: 1, expense: -1, saving: -1 };

export const symbol = (c) => (c === "USD" ? "$" : c === "NGN" ? "₦" : `${c} `);
